import { FC, SVGProps } from 'react';

export const GemFilled: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.27491 3.32794C5.33105 3.24774 5.42279 3.19998 5.52068 3.19998H6.85348L5.95348 6.79998H2.84448L5.27491 3.32794ZM7.39657 6.79998L8.29657 3.19998H9.4792L10.5592 6.79998H7.39657ZM12.0208 6.79998L10.9408 3.19998H12.4794C12.5773 3.19998 12.669 3.24774 12.7251 3.32794L15.1556 6.79998H12.0208ZM3.11579 8.19998H14.8843L9.21888 14.243C9.10036 14.3695 8.89968 14.3695 8.78116 14.243L3.11579 8.19998Z"
			fill="currentColor"
		/>
	</svg>
);
